import { DEBIT_NOTE_REQUEST, CREATE_DEBIT_NOTE, GET_DEBIT_NOTES, GET_DEBIT_NOTES_PAGE, UPDATE_DEBIT_NOTE, DELETE_DEBIT_NOTE,
  DEBIT_NOTE_REQUEST_FAILURE, DEBIT_NOTE_REQUEST_SUCCESS } from '../types';

const initialState = {
  debitNotes: [],
  debitNotesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const debitNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEBIT_NOTE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DEBIT_NOTES: {
      return {
        ...state,
        debitNotes: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DEBIT_NOTES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        debitNotesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_DEBIT_NOTE: {
      return {
        ...state,
        debitNotes: [action.payload, ...state.debitNotes],
        loading: false,
        error: null
      };
    }
    case UPDATE_DEBIT_NOTE: {
      const debitNotesData = state.debitNotes.slice(0);
      const uIndex = debitNotesData.findIndex((data) => data.id === action.payload.id);
      debitNotesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        debitNotes: [ ...debitNotesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_DEBIT_NOTE: {
      const debitNotes = state.debitNotes?.slice(0);
      const index = debitNotes.findIndex((data) => data.id === action.id);
      if (index > -1) {
        debitNotes.splice(index, 1);
      }
      return {
        ...state,
        debitNotes: [...debitNotes],
        loading: false,
        error: null
      }
    }
    case DEBIT_NOTE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DEBIT_NOTE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default debitNoteReducer;